/**
 * Suite du dictionnaire FR → EN (produits laitiers, féculents, etc.)
 */

export const translationsFRtoENPart2 = {
  œuf: "egg",
  œufs: "egg",
  oeufs: "egg",
  oeuf: "egg",
  lait: "milk",
  fromage: "cheese",
  beurre: "butter",
  crème: "cream",
  creme: "cream",
  "creme fraiche": "cream",
  "crème fraîche": "cream",
  yaourt: "yogurt",
  yogourt: "yogurt",
  parmesan: "parmesan",
  mozzarella: "mozzarella",
  riz: "rice",
  pâtes: "pasta",
  pates: "pasta",
  pâte: "pasta",
  pate: "pasta",
  spaghetti: "pasta",
  macaroni: "pasta",
  pain: "bread",
  farine: "flour",
  pommes: "apple",
  pomme: "apple",
  bacon: "bacon",
  jambon: "ham",
  saucisse: "sausage",
  saucisses: "sausage",
  citron: "lemon",
  citrons: "lemon",
  orange: "orange",
  banane: "banana",
  bananes: "banana",
  fraise: "strawberry",
  fraises: "strawberry",
  mangue: "mango",
  ananas: "pineapple",
  peche: "peach",
  pêche: "peach",
  poire: "pear",
  basilic: "basil",
  persil: "parsley",
  thym: "thyme",
  romarin: "rosemary",
  origan: "oregano",
  menthe: "mint",
  coriandre: "coriander",
  cumin: "cumin",
  paprika: "paprika",
  curry: "curry",
  gingembre: "ginger",
  cannelle: "cinnamon",
  sucre: "sugar",
  sel: "salt",
  poivre: "pepper",
  huile: "oil",
  "huile d'olive": "olive oil",
  vinaigre: "vinegar",
  moutarde: "mustard",
  ketchup: "ketchup",
  mayonnaise: "mayonnaise",
  sauce: "sauce",
  "sauce soja": "soy sauce",
  miel: "honey",
  chocolat: "chocolate",
  cacao: "cocoa",
  crevette: "prawns",
  moules: "mussels",
  moule: "mussels",
  huitres: "oysters",
  huitre: "oysters",
  crabe: "crab",
  homard: "lobster",
  calamar: "squid",
  calamars: "squid",
  noix: "nuts",
  amande: "almond",
  amandes: "almond",
  noisette: "hazelnut",
  noisettes: "hazelnut",
  cacahuete: "peanut",
  cacahuètes: "peanut",
  pistache: "pistachio",
};
